import { getCurrentUser } from './current_user.js?v=20260722a';

const optimisticPreferencesByUser = new Map();
let preferenceWriteQueue = Promise.resolve();

function plainObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function currentUserId(user = getCurrentUser()) {
  return String(user?.benutzer_id ?? user?.id ?? '').trim();
}

function userPreferenceOwnerId() {
  return currentUserId();
}

function currentUserPreferences(user = getCurrentUser()) {
  const userId = currentUserId(user);
  return {
    ...plainObject(user?.ui_preferences ?? user?.uiPreferences),
    ...plainObject(optimisticPreferencesByUser.get(userId))
  };
}

function getUserPreference(key, fallback = null) {
  const normalizedKey = String(key || '').trim();
  if (!normalizedKey) return fallback;
  const preferences = currentUserPreferences();
  return Object.prototype.hasOwnProperty.call(preferences, normalizedKey)
    ? preferences[normalizedKey]
    : fallback;
}

function setUserPreference(key, value) {
  const normalizedKey = String(key || '').trim();
  const user = getCurrentUser();
  const userId = currentUserId(user);
  if (!normalizedKey || !userId) return Promise.resolve(false);

  optimisticPreferencesByUser.set(userId, {
    ...plainObject(optimisticPreferencesByUser.get(userId)),
    [normalizedKey]: value
  });

  let serializedValue;
  try {
    serializedValue = JSON.parse(JSON.stringify(value));
  } catch (_error) {
    return Promise.resolve(false);
  }
  preferenceWriteQueue = preferenceWriteQueue
    .catch(() => undefined)
    .then(async () => {
      if (currentUserId() !== userId) return false;
      const response = await fetch('/api/auth/preferences', {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ key: normalizedKey, value: serializedValue }),
        keepalive: true
      });
      if (!response.ok) throw new Error(`Benutzereinstellung konnte nicht gespeichert werden (${response.status}).`);
      return true;
    })
    .catch(error => {
      console.warn(error?.message || 'Benutzereinstellung konnte nicht gespeichert werden.');
      return false;
    });
  return preferenceWriteQueue;
}

export {
  getUserPreference,
  setUserPreference,
  userPreferenceOwnerId
};
